/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Important_LabelInputs */



/**
* | output |
* | --- |
* | "Important:" |
*
* @param {Embed_Captions_Important_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_important_label = /** @type {((inputs?: Embed_Captions_Important_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Important_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Important :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wichtig:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importante:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Важный:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importante:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重要的：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("重要：")
	if (locale === "hi") return /** @type {LocalizedString} */ ("महत्वपूर्ण:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importante:")
	return /** @type {LocalizedString} */ ("Important:")
});